<template lang="pug">
section.section.levels.is-medium
	.container.level
		.level-item.has-text-centered
			div
				router-link(to='/inhalt/edition')
				p.heading {{ $t("home.facsimiles") }}
				p.title 321
		.level-item.has-text-centered
			div
				router-link(to='/inhalt/archiv')
				p.heading {{ $t("home.archiveitems") }}
				p.title 34
		.level-item.has-text-centered
			div
				router-link(to='/inhalt/projekte')
				p.heading {{ $t("home.projects") }}
				p.title 45
</template>

<script>
const { messages } = require("../../i18n/home");

export default {
    name: "StatBar",
    i18n: { messages },
};
</script>
